import * as types from '../../lib/actionTypes.es6';

export function getIprsConfigsRequest(partner) {
  return { type: types.GET_IPRS_CONFIGS_REQUEST, payload: partner };
}
export function getIprsConfigsSuccess(configs) {
  return { type: types.GET_IPRS_CONFIGS_SUCCESS, payload: configs };
}
export function getIprsConfigsFail(error) {
  return { type: types.GET_IPRS_CONFIGS_FAIL, payload: error };
}

export function getIprsConfigRawRequest(partner, type) {
  return { type: types.GET_IPRS_CONFIG_RAW_REQUEST, payload: { partner, type } };
}
export function getIprsConfigRawSuccess(raw) {
  return { type: types.GET_IPRS_CONFIG_RAW_SUCCESS, payload: raw };
}
export function getIprsConfigRawFail(error) {
  return { type: types.GET_IPRS_CONFIG_RAW_FAIL, payload: error };
}
export function getIprsConfigRawReset() {
  return { type: types.GET_IPRS_CONFIG_RAW_RESET };
}

export function publishIprsConfigRequest(partner, type, rawYaml) {
  return { type: types.PUBLISH_IPRS_CONFIG_REQUEST, payload: { partner, type, rawYaml } };
}
export function publishIprsConfigSuccess(result) {
  return { type: types.PUBLISH_IPRS_CONFIG_SUCCESS, payload: result };
}
export function publishIprsConfigFail(error) {
  return { type: types.PUBLISH_IPRS_CONFIG_FAIL, payload: error };
}
export function publishIprsConfigReset() {
  return { type: types.PUBLISH_IPRS_CONFIG_RESET };
}

export function createIprsConfigRequest(partner, rawYaml) {
  return { type: types.CREATE_IPRS_CONFIG_REQUEST, payload: { partner, rawYaml } };
}
export function createIprsConfigSuccess(result) {
  return { type: types.CREATE_IPRS_CONFIG_SUCCESS, payload: result };
}
export function createIprsConfigFail(error) {
  return { type: types.CREATE_IPRS_CONFIG_FAIL, payload: error };
}
export function createIprsConfigReset() {
  return { type: types.CREATE_IPRS_CONFIG_RESET };
}
